<template>
  <div>
    <h1 class="paragraph">
      Welcome to our first experiment!
    </h1>
    <p class="paragraph">
      Before we get started: How familiar are you with psychological theories
      (like social proof).
    </p>
    <div class="container">
      <div class="text">not at all</div>
      <div
        :class="`letter ${selected === box && 'letter-selected'}`"
        v-for="box in boxes"
        v-bind:key="box"
        @click="setSelected(box)"
      >
        {{ box }}
      </div>
      <div class="text">very</div>
    </div>
    <bg-button
      class="button"
      @click="selected === null ? null : $router.push({ name: 'stepthree' })"
      text="Continue"
    ></bg-button>
  </div>
</template>

<style scoped>
.header {
  margin-bottom: 80px;
}
.paragraph {
  margin-bottom: 30px;
}
.button {
  margin-top: 40px;
}
.container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.letter {
  background-color: white;
  color: var(--bg-color-gray-medium);
  height: 30px;
  width: 30px;
  border-radius: var(--bg-border-radius);
  cursor: pointer;
  margin: 5px;
  transition: all 0.4 ease-in-out;
}
.letter-selected {
  background-color: var(--bg-color-bg-medium);
  color: white;
}
.text {
  margin: 10px;
  font-size: 14px;
}
</style>

<script>
import BgButton from "../components/bg-button";
export default {
  name: "App",
  components: {
    BgButton
  },
  data() {
    return {
      selected: null,
      boxes: [1, 2, 3, 4, 5]
    };
  },
  methods: {
    setSelected(item) {
      this.selected = item;
    }
  }
};
</script>
